export function formatMoneyCents(amountCents, currency = "cad") {
  const cents = Number(amountCents);
  if (!Number.isFinite(cents)) return "—";
  const code = String(currency ?? "cad").toUpperCase();
  return (cents / 100).toLocaleString("en-CA", {
    style: "currency",
    currency: code,
  });
}

export function formatSignedMoneyCents(amountCents, currency = "cad") {
  const cents = Number(amountCents);
  if (!Number.isFinite(cents)) return "—";
  const prefix = cents > 0 ? "+" : "";
  return `${prefix}${formatMoneyCents(cents, currency)}`;
}

export function formatSubscriptionAmount(subscription) {
  if (subscription?.amountCents == null) return null;
  const amount = formatMoneyCents(subscription.amountCents, subscription.currency);
  const interval = String(subscription.interval ?? "").toLowerCase();
  if (interval === "month") return `${amount} / month`;
  if (interval === "year") return `${amount} / year`;
  if (interval === "week") return `${amount} / week`;
  return amount;
}

export function humanizeBalanceTransactionType(type) {
  const key = String(type ?? "").toLowerCase();
  const map = {
    charge: "Charge",
    payout: "Payout",
    refund: "Refund",
    adjustment: "Adjustment",
    transfer: "Transfer",
    payment: "Payment",
  };
  return map[key] ?? (key ? key.charAt(0).toUpperCase() + key.slice(1) : "Activity");
}
